
import {of as observableOf,  Observable, Subscription } from 'rxjs';
import { AfterViewInit, Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, NgForm, Validators } from '@angular/forms';
import { MetricsService } from './metrics.service';
import { AuthService } from '../../../../core/auth.service';
import { BaseService } from '../../../../shared/base.service';
import { ClinicsService } from '../../../../clinics/clinics.service';
import { BaseComponent } from '../../../../shared/base.component';
import { AppService } from '../../../../app.service';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from '../../../../users/users.service';
import { HomeService } from '../../../../home/home.service';
import { MaintenanceService } from '../../../../maintenance/maintenance.service';
import { SecureApi } from '../../../../core/secure.api';
import {CoreService} from "../../../../core/core.service";
import * as moment from 'moment';
import {B2CAdminComponent} from "../../b2c-admin.component";
import {MaintenanceComponent} from "../../../../maintenance/maintenance.component";
import {MetricsMockup} from "./metrics.interface";
import {MetricsModel} from "./metrics.model";
import * as Highcharts from 'highcharts';

@Component({
    selector: 'metrics-component',
    templateUrl: './metrics.component.html',
    styleUrls: ['./metrics.component.scss'],
    providers: [MetricsService]
})

export class MetricsComponent extends B2CAdminComponent implements OnInit, AfterViewInit {
    helpClinicProfile: any;
    @Input() isHome = false;
    @Input() filters;
    roles: Object[] = [];
    userRoleId: number;
    isEditable: boolean = false;
    data: any;
    collapse = true;
    metrics = new MetricsMockup();
    color = {
        total : '#202A4D',
        res : '#59AD93',
        sub : '#FF6B92'
    };
    serviceMockup = [{
        service: 'Starter',
        paid : 3,
        completed: 16
        },
        {
            service: 'First Call Package (Appointment)',
            paid : 3,
            completed: 0
        }];
    // define what table columns to display [column key, label, css class]
    readonly tableColumns = [
        ['service', 'Service', 'col-xs-4'],
        ['paid', 'Payed', 'col-xs-4'],
        ['completed', 'Completed', 'col-xs-4'],
    ];
    response: any;

    Highcharts: typeof Highcharts = Highcharts;
    chartConstructor: string = 'chart'; // optional string, defaults to 'chart'
    chartCallback: Highcharts.ChartCallbackFunction = function (chart) {  } // optional function, defaults to null
    chartOptions: Highcharts.Options = {};
    // Pie Chart data
    chartTypes = [
        {
            type: 'pie',
            name: this.translate.instant('Started / Completed Flows'),
            options: this.chartOptions,
            data: [{
                value: 'evaluation_start',
                name: this.translate.instant('Started'),
            },{
                value: 'evaluation_done',
                name: this.translate.instant('Completed'),
            }]
        },
        {
            type: 'pie',
            name: this.translate.instant('Started / Completed Self-Reports'),
            options: this.chartOptions,
            data: [{
                value: 'sr_start',
                name: this.translate.instant('Started'),
            },{
                value: 'sr_done',
                name: this.translate.instant('Completed'),
            }]
        },
        {
            name: this.translate.instant('Booked / Completed calls'),
            options: this.chartOptions,
            type: 'pie',
            data: [{
                value: 'booking_appointment',
                name: this.translate.instant('Booked'),
            },{
                value: 'booking_show',
                name: this.translate.instant('Completed(Show)'),
            },{
                value: 'booking_not_show',
                name: this.translate.instant('Uncompleted(No-Show)'),
            }]
        },
        {
            name: this.translate.instant('Registered / Verified patients'),
            options: this.chartOptions,
            type: 'pie',
            data: [{
                value: 'register_patient',
                name: this.translate.instant('Registered'),
            },{
                value: 'verify_patient',
                name: this.translate.instant('Verified'),
            }]
        },
    ];
    loadedData = false;
    chartGenerated = false;
    plotOptions: {};
    services : {
        starter: {
            service: 'Starter',
            starter_paid: 0,
            starter_completed: 0,
        },
        appointment:
            {
                service: 'First Call Package (Appointment)',
                appointment_paid: 0,
                appointment_completed: 0,

            }
    };

    constructor(public authService: AuthService,
                public coreService: CoreService,
                public router: Router,
                public translate: TranslateService,
                public fb: FormBuilder,
                public baseService: BaseService,
                public appService: AppService,
                public usersService: UsersService,
                public clinicService: ClinicsService,
                public homeService: HomeService,
                public maintenanceService: MaintenanceService,
                public secureApi: SecureApi,
                public maintenanceComponent: MaintenanceComponent,
                public service: MetricsService)  {
        super(authService, coreService, router, translate, fb, baseService, appService, usersService, homeService, clinicService, maintenanceService, secureApi, maintenanceComponent);
    }

    ngOnInit() {
        this.userRoleId = this.authService.user['role_id'];
        this.searchInfo = new MetricsModel();
        this.sortedColumn = 'started';
        this.token = this.authService.user['token'];

        // sort
        this.initSorting();
    }

    ngAfterViewInit() {
    }

    /**
     * @param {SimpleChanges} changes
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes['filters'] && this.filters) {
            return this.getItems();
        }
    }

    getItems() {
        // this.dateOptionFilter.from = this.dateOptionFilter.from
        this.service.getAll(this.filters).subscribe(response => {
            this.isLoading = false;
            this.metrics = response['metrics'];
            return this.setData(response);
        });
    }

    getRandomInt(min, max) {
        const minCeiled = Math.ceil(min);
        const maxFloored = Math.floor(max);
        return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled); // The maximum is exclusive and the minimum is inclusive
    }

    setData(data: any): void {
        this.data =  this.metrics;
        for(let chart of this.chartTypes){
            let chartData = [];
            for(let type of chart['data']){
                let item = {
                    name: type['name'],
                    label: type['name'],
                    y: this.data[type['value']]
                };
                chartData.push(item);
            }
            chart.options = {
                chart: {
                    type: 'pie',
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    style: {
                        fontFamily: 'Cera Pro',
                    },
                    events: {

                    }
                },
                accessibility: {
                    point: {
                        valueSuffix: '%'
                    }
                },
                title: {
                    text: chart.name,
                    style: {
                        fontFamily: 'Cera Pro Bold',
                        fontSize: '18px'
                    }
                },
                tooltip: {
                    pointFormat: '{point.name}: <b>{point.percentage:.1f}%</b>'
                },
                legend: {
                    enabled: true,
                },
                plotOptions: {
                    pie: {
                        innerSize: '75%',
                        depth: 45,
                        allowPointSelect: true,
                        cursor: 'pointer',
                        borderRadius: 8,
                        showInLegend: true,
                        dataLabels: {
                            enabled: true,
                            distance: 30,
                            format: '<b>{point.y}</b>',
                            style: {
                                fontSize: '12px'
                            }
                        } as Highcharts.PlotAoDataLabelsOptions
                    }
                },
                series: [{
                    name: chart.name,
                    type: 'pie',
                    colorByPoint: true,
                    innerSize: '75%',
                    data: chartData
                }],
                colors: [
                    this.color.total,
                    this.color.res,
                    this.color.sub,
                ],
                exporting: {
                    enabled: true
                }
            };
        }
        this.services =
            {
                starter: {
                    service: 'Starter',
                    starter_paid: data['metrics']['starter_paid'],
                    starter_completed: data['metrics']['starter_completed'],
                },
                appointment:
                    {
                        service: 'First Call Package (Appointment)',
                        appointment_paid: data['metrics']['appointment_paid'],
                        appointment_completed: data['metrics']['appointment_completed'],

                    }
            };
        return this.generateHighChart();
    }

    generateHighChart(){
        this.chartGenerated = true;
    }

    sortData(column) {
        if (column === 'created_at') {
            column = 'created_at_sort';
        }

        this.sort(column, false, this.sortUsingApi);
    }
}
